/* ORIGINAL ALBEUX, Task 5: the ALBEUX logo in the footer (above the policy links) has empty space built into the left of the picture,
   so on a phone it looked pushed in from the left edge. This measures how much empty space the picture has on its left
   and pulls the picture left by exactly that amount, so the first letter sits flush with the left edge, in line with the links below it.
   It reads the picture once in the background; if the browser cannot read it, nothing changes. */
(function () {
  if (window.__albeuxFooterTrim) return;
  window.__albeuxFooterTrim = true;

  var info = null;
  var infoSrc = '';
  var queued = false;

  function logo() {
    return document.querySelector('.albeux-footer-links__logo-image');
  }

  function apply() {
    queued = false;
    var img = logo();
    if (!img || !info) return;
    var bw = img.clientWidth;
    var bh = img.clientHeight;
    if (!bw || !bh) return;
    var s = Math.min(bw / info.w, bh / info.h);
    var offset = (bw - info.w * s) / 2 + info.first * s;
    img.style.marginLeft = offset > 0.5 ? '-' + offset.toFixed(2) + 'px' : '';
  }

  function queue() {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(apply);
  }

  function measure() {
    var img = logo();
    if (!img) return;
    var src = img.currentSrc || img.src;
    if (!src) return;
    if (info && infoSrc === src) { queue(); return; }
    var probe = new Image();
    probe.crossOrigin = 'anonymous';
    probe.onload = function () {
      try {
        var nw = probe.naturalWidth;
        var nh = probe.naturalHeight;
        if (!nw || !nh) return;
        var cw = Math.min(nw, 1200);
        var ch = Math.max(1, Math.round(nh * cw / nw));
        var c = document.createElement('canvas');
        c.width = cw;
        c.height = ch;
        var x = c.getContext('2d');
        x.drawImage(probe, 0, 0, cw, ch);
        var d = x.getImageData(0, 0, cw, ch).data;
        var first = cw;
        for (var col = 0; col < cw && first === cw; col++) {
          for (var row = 0; row < ch; row++) {
            var i = (row * cw + col) * 4;
            if (d[i + 3] > 24 && Math.max(d[i], d[i + 1], d[i + 2]) > 90) { first = col; break; }
          }
        }
        if (first >= cw) return;
        info = { w: cw, h: ch, first: first };
        infoSrc = src;
        queue();
      } catch (err) {}
    };
    probe.src = src;
  }

  function init() { measure(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  window.addEventListener('load', init);
  window.addEventListener('resize', queue, { passive: true });
  document.addEventListener('shopify:section:load', init);
})();
